/**
 * Asynchronously loads the component for FlowToHireSettings
 */

import loadable from 'utils/loadable';

export const FlowToHireSettings = loadable(() => import('./index'), {
  fallback: null,
});
